import { render } from "./PartTransactions.vue?vue&type=template&id=0fdc6bd9"
import script from "./PartTransactions.vue?vue&type=script&lang=js"
export * from "./PartTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__